export default __webpack_public_path__ + "static/farming-d13dfc651c7ff25b6801d1bd10577ce9.webp";